<template>
  <div>
    <div class="vx-row m-2">
      <div class="router-header flex flex-wrap items-center mb-6 mt-5">
        <div
          class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light"
        >
          <h2 class="mb-1">{{ $t("report") }}</h2>
        </div>
      </div>
    </div>
    <vs-card class="px-10 py-10">
      <div>
        <vs-row vs-w="12" class="my-5">
          <vs-col
            vs-type="flex"
            class="mb-1"
            vs-justify="center"
            vs-align="center"
            vs-lg="3"
            vs-sm="3"
            vs-xs="12"
          >
            <div class="h7 px-1 pt-1"></div>
            <v-date-picker
              v-if="$i18n.locale == 'th'"
              class="cursor-pointer"
              mode="range"
              v-model="selectedDate"
              :locale="$i18n.locale"
              :buddhist="true"
              :max-date="new Date()"
              :popover="{ placement: 'right-center', visibility: 'click' }"
            >
              <vs-button size="small" color="#cccccc" type="border">
                <div class="vx-row">
                  <vs-icon size="small" icon="today" color="dark"></vs-icon>
                  <h6 class="mt-1 mx-2">
                    {{ setFormat(selectedDate.start) }} -
                    {{ setFormat(selectedDate.end) }}
                  </h6>
                </div>
              </vs-button>
            </v-date-picker>
            <v-date-picker
              v-else
              class="cursor-pointer"
              mode="range"
              v-model="selectedDate"
              :locale="$i18n.locale"
              :buddhist="false"
              :max-date="new Date()"
              :popover="{ placement: 'right-center', visibility: 'click' }"
            >
              <vs-button size="small" color="#cccccc" type="border">
                <div class="vx-row">
                  <vs-icon size="small" icon="today" color="dark"></vs-icon>
                  <h6 class="mt-1 mx-2">
                    {{ setFormat(selectedDate.start) }} -
                    {{ setFormat(selectedDate.end) }}
                  </h6>
                </div>
              </vs-button>
            </v-date-picker>
          </vs-col>
          <vs-col
            vs-type="flex"
            class="mb-1"
            vs-align="center"
            vs-lg="3"
            vs-sm="3"
            vs-xs="12"
          >
            <div class="h7 px-1">{{ $t("RefineryTable.RefineryName") }} :</div>
            <v-select
              class="w-2/3"
              v-model="selectedRefinery"
              :options="optionsRefinery"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            /><br />
          </vs-col>
          <vs-col
            vs-type="flex"
            class="mb-1"
            vs-align="center"
            vs-lg="4"
            vs-sm="4"
            vs-xs="12"
          >
            <div class="h7 px-1">{{ $t("destinationType") }} :</div>
            <v-select
              class="w-4/5"
              v-model="selectedDestinationType"
              :options="optionsDestinationType"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            /><br />
          </vs-col>
          <vs-col vs-type="flex" class="mb-1" vs-lg="2" vs-sm="2" vs-xs="12">
            <vs-button
              class="py-2 px-5"
              color="#0066cc"
              type="border"
              icon-pack="feather"
              icon="icon-search"
              @click="searchReport()"
              >{{ $t("search") }}</vs-button
            >
          </vs-col>
        </vs-row>
        <hr class="my-10" />
        <vs-table
          maxHeight="460px"
          class="static"
          :max-items="descriptionItems[0]"
          description
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
          pagination
          :data="reports"
        >
          <template slot="header">
            <h4 class="mb-5">
              {{ $t("ShipmentTable.Shipment") }}
            </h4>
            <div v-if="this.destinationType == 'transit'">
              <vs-button
                class="py-2 px-5 h7 mb-3"
                color="#0066cc"
                type="filled"
                icon-pack="feather"
                icon="icon-printer"
                @click="detailReportTransit()"
                >Print</vs-button
              >
              <download-excel
                :data="reports"
                :fields="jsonFieldsTransit"
                name="OFMs.xls"
              >
                <vs-button
                  class="py-2 px-5 h7 mb-3"
                  color="#0066cc"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-download"
                  >{{ $t("download") }} Excel</vs-button
                >
              </download-excel>
            </div>
            <div v-else>
              <vs-button
                class="py-2 px-5 h7 mb-3"
                color="#0066cc"
                type="filled"
                icon-pack="feather"
                icon="icon-printer"
                @click="detailReportDmtEp()"
                >Print</vs-button
              >
              <download-excel
                :data="reports"
                :fields="jsonFieldsDomisticExport"
                name="OFMs.xls"
              >
                <vs-button
                  class="py-2 px-5 h7 mb-3"
                  color="#0066cc"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-download"
                  >{{ $t("download") }} Excel</vs-button
                >
              </download-excel>
            </div>
          </template>
          <template slot="thead">
            <vs-th>
              {{ $t("RefineryTable.Id") }}
            </vs-th>
            <vs-th sort-key="departed_at_formatted_be">
              {{ $t("RefineryTable.TransferStart") }}
            </vs-th>
            <vs-th>
              {{ $t("RefineryTable.RefineryName") }}
            </vs-th>
            <vs-th>
              {{ $t("RefineryTable.TankerName") }}
            </vs-th>
            <vs-th v-if="destinationType == 'transit'">
              {{ $t("TankerTable.MMSI") }}
            </vs-th>
            <vs-th v-else>
              {{ $t("TankerTable.OilType") }}
            </vs-th>
            <vs-th v-if="destinationType != 'transit'">
              {{ $t("TankerTable.TransferVolume") }}
            </vs-th>
            <vs-th sort-key="volumes">
              {{ $t("RefineryTable.TransferVolume") }} ( {{ $t("Liter") }} )
            </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ tr.index + 1 }}
              </vs-td>

              <vs-td :data="data[indextr].departed_at_formatted_be">
                {{ data[indextr].departed_at_formatted_be }}
              </vs-td>

              <vs-td :data="data[indextr].station.code">
                {{ data[indextr].station.code }}
              </vs-td>

              <vs-td
                v-if="data[indextr].vessel != null"
                :data="data[indextr].vessel.name"
              >
                {{ data[indextr].vessel.name }}
              </vs-td>
              <vs-td v-else> - </vs-td>

              <div v-if="destinationType == 'transit'">
                <vs-td :data="data[indextr].vessel.mmsi">
                  {{ data[indextr].vessel.mmsi || "-" }}
                </vs-td>
              </div>
              <div v-else>
                <vs-td :data="data[indextr].oil_type">
                  {{ data[indextr].oil_type }}
                </vs-td>
              </div>
              <vs-td
                v-if="destinationType != 'transit'"
                :data="data[indextr].volume"
              >
                {{ data[indextr].volume }}
              </vs-td>

              <vs-td :data="data[indextr].volumes">
                {{ getVolume(data[indextr].volumes) }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-card>
  </div>
</template>

<script>
import moment from "moment";
import _ from "lodash";
import { formatNumber } from "@/utils/index";
import vSelect from "vue-select";
import { REFINERY_ID, REFINERY_NAME } from "@/constant";
import downloadExcel from "vue-json-excel";
import { mapState } from "vuex";
import { OIL_TYPE } from "../constant/index";

export default {
  name: "ReportTable",
  components: {
    vSelect,
    downloadExcel,
  },
  data() {
    return {
      config: {
        startDate: moment().format("DD/MM/YYYY"),
        endDate: moment().format("DD/MM/YYYY"),
        destination_type: "",
        isDomestic: "true",
      },
      destinationType: "transit",
      selectedDate: {
        start: new Date(),
        end: new Date(),
      },
      optionsRefinery: [
        { id: "", label: "ทั้งหมด" },
        { id: REFINERY_ID.IRPC, label: REFINERY_NAME.IRPC },
        { id: REFINERY_ID.SPRC, label: REFINERY_NAME.SPRC },
        { id: REFINERY_ID.TOP, label: REFINERY_NAME.TOP },
        { id: REFINERY_ID.PTTGC, label: REFINERY_NAME.PTTGC },
        { id: REFINERY_ID.ESSO, label: REFINERY_NAME.ESSO },
        { id: REFINERY_ID.BCP, label: REFINERY_NAME.BCP },
      ],
      optionsDestinationType: [
        {
          id: "greenDiesel",
          label: "น้ำมันเขียว",
          domestic: false,
          destination_type: "transit",
        },
        {
          id: "domesticOil",
          label: "น้ำมันในประเทศ",
          domestic: true,
          destination_type: "",
        },
        {
          id: "exportOil",
          label: "น้ำมันส่งออกนอกประเทศ",
          domestic: false,
          destination_type: "export",
        },
      ],
      optionsTanker: [
        { id: 1, label: "foo" },
        { id: 3, label: "bar" },
        { id: 2, label: "baz" },
      ],
      selectedRefinery: { id: "", label: "ทั้งหมด" },
      selectedDestinationType: {
        id: "greenDiesel",
        label: "น้ำมันเขียว",
        domestic: false,
        destination_type: "transit",
      },
      selectedTanker: "",
      descriptionItems: [10, 25, 50, 100],
      jsonFieldsTransit: {
        ลำดับ: {
          field: "index",
          callback: (value) => {
            return `${value + 1}`;
          },
        },
        วันที่เริ่ม: "departed_at_formatted_be",
        ชื่อโรงกลั่น: "station.code",
        MMSI: "vessel.mmsi",
        ชื่อเรือบรรทุกน้ำมัน: "vessel.name",
        "ปริมาณน้ำมัน (ลิตร)": "volumes",
      },
      jsonFieldsDomisticExport: {
        ลำดับ: {
          field: "index",
          callback: (value) => {
            return `${value + 1}`;
          },
        },
        วันที่เริ่ม: "departed_at_formatted_be",
        ชื่อโรงกลั่น: "station.code",
        ชื่อเรือบรรทุกน้ำมัน: "vessel.name",
        ประเภทน้ำมัน: "oil_type",
        "ปริมาณน้ำมัน (ลิตร)": "volume",
        "ปริมาณน้ำมันรวม (ลิตร)": {
          field: "volumes",
          callback: (value) => {
            return `${this.getVolume(value)}`;
          },
        },
      },
    };
  },
  watch: {
    reports() {
      for (let i = 0; i < this.reports.length; i++) {
        this.reports[i].index = i;
      }
    },
  },
  computed: {
    ...mapState({
      reports: (state) => state.vesselTrip.data,
    }),
  },
  mounted() {
    this.$store.dispatch("activeOilCard", OIL_TYPE.ALL);
    this.searchReport();
  },
  methods: {
    getVolume(data) {
      let value = _.chain(data)
        .map((a) => {
          return Number(a);
        })
        .sum();
      return formatNumber(value);
    },
    setDateFormat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    setFormat(date) {
      const locale = this.$i18n.locale;
      if (locale == "th") {
        const newDate = moment(date).add(543, "years").format("DD/MM/YYYY");
        return newDate;
      } else {
        const newDate = moment(date).format("DD/MM/YYYY");
        return newDate;
      }
    },
    searchReport() {
      if (this.selectedRefinery != null) {
        this.config.station_id = this.selectedRefinery.id;
        this.config.station_name = this.selectedRefinery.label;
      } else {
        this.config.station_id = "";
      }

      if (this.selectedDestinationType.destination_type != "transit") {
        this.destinationType = this.selectedDestinationType.destination_type;
        this.config.destination_type = this.selectedDestinationType.destination_type;
      } else {
        this.destinationType = "transit";
        this.config.destination_type = "transit";
      }
      this.config.startDate = this.setDateFormat(this.selectedDate.start);
      this.config.endDate = this.setDateFormat(this.selectedDate.end);
      this.config.isDomestic = this.selectedDestinationType.domestic;
      this.config.oilType_name = this.selectedDestinationType.label;
      localStorage.setItem("config", JSON.stringify(this.config));
      this.$store.dispatch("getVesselTrip", this.config);
    },
    detailReportTransit() {
      localStorage.setItem("config", JSON.stringify(this.config));
      let routeData = this.$router.resolve({ name: "DetailReportTransit" });
      window.open(routeData.href, "_blank");
    },
    detailReportDmtEp() {
      localStorage.setItem("config", JSON.stringify(this.config));
      let routeData = this.$router.resolve({ name: "DetailReportDmtEp" });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style>
.tableship {
  height: 100%;
}
@media print {
  #selecttime {
    display: none;
  }
}
</style>
